export default (scrollId) => {
  const section = document.querySelector(`[data-scroll-id="${scrollId}"]`)
  if (!section) return false

  const topOfSection = section.getBoundingClientRect().top + window.scrollY
  window.scrollTo(0, topOfSection)
  return true
}
